<template>
  <div
    class="sticky bottom-0 left-0 right-0 z-50 p-4 bg-gray-100 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-lg mb-0"
    style="margin-bottom: -1px"
  >
    <div
      class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4"
    >
      <div class="flex items-start gap-3">
        <UIcon
          name="i-heroicons-shield-check"
          class="flex-shrink-0 h-6 w-6 text-primary -mt-0.5"
        />
        <p class="text-gray-700 dark:text-gray-300 text-sm">
          We use tracking cookies to understand how you use the product and help
          us improve it. Please accept cookies to help us improve.
        </p>
      </div>
      <div class="flex gap-2 shrink-0">
        <UButton
          color="primary"
          variant="solid"
          size="sm"
          @click="acceptCookies"
          data-testid="accept-cookies"
        >
          Accept cookies
        </UButton>
        <UButton
          color="gray"
          variant="ghost"
          size="sm"
          @click="declineCookies"
          data-testid="decline-cookies"
        >
          Decline cookies
        </UButton>
      </div>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['hide-banner'])
const { $clientPosthog } = useNuxtApp()
const { setConsentPreference } = useGdpr()

// Add padding to ensure footer is visible below the banner
onMounted(() => {
  document.body.classList.add('has-cookie-banner')
})

// Remove the padding when banner is hidden
const acceptCookies = () => {
  document.body.classList.remove('has-cookie-banner')

  // Use the client PostHog instance
  try {
    if ($clientPosthog) {
      // Opt in to tracking
      $clientPosthog.opt_in_capturing()
      // Switch to more persistent storage now that we have consent
      $clientPosthog.set_config({ persistence: 'localStorage+cookie' })
    }
  } catch (error) {
    console.error('Error opting into PostHog:', error)
  }

  // Store the preference in localStorage and cookie
  setConsentPreference('accepted')

  emit('hide-banner')
}

const declineCookies = () => {
  document.body.classList.remove('has-cookie-banner')

  // Use the client PostHog instance
  try {
    if ($clientPosthog) {
      $clientPosthog.opt_out_capturing()
    }
  } catch (error) {
    console.error('Error opting out of PostHog:', error)
  }

  // Store the preference in localStorage and cookie
  setConsentPreference('declined')

  emit('hide-banner')
}
</script>

<style>
.has-cookie-banner {
  padding-bottom: 0;
}
</style>
